import React from 'react';
import * as env from 'config/environment';
import { useRouting } from 'hooks/useRouting';
import { isPremium } from 'components/features/utils/userStatus';

export const Notification = ({ isLinkedLine }: { isLinkedLine: boolean }) => {
  const routing = useRouting();
  const onNotificationSettingBannerClick = (): void => {
    routing.pushRouting({ path: `/notificationSetting` }, true);
  };

  return (
    <>
      {!isLinkedLine && isPremium() && (
        <a href={env.lineAddFriendURL}>
          <div className="h-24 flex flex-row items-center mx-2 my-4 px-3 border border-bluegray-300 bg-white rounded-lg cursor-pointer">
            <div className="w-16">
              <img
                src="/static/images/report/line_notice.svg"
                alt=""
                className="mx-auto"
              />
            </div>
            <div className="flex flex-col ml-4 font-bold">
              <div className="text-xs">毎日の資産変動をお知らせ</div>
              <div className="text-base">LINEで通知を受け取る</div>
            </div>
            <div className="icon-external-link ml-auto mr-2 text-bluegray-500"></div>
          </div>
        </a>
      )}
      <div
        className="h-24 flex flex-row items-center mx-2 my-4 pl-3 border border-bluegray-300 bg-white rounded-lg cursor-pointer"
        onClick={() => onNotificationSettingBannerClick()}>
        <div className="w-16">
          <img
            src="/static/images/report/icon-bell.svg"
            alt=""
            className="mx-auto"
          />
        </div>
        <div className="flex flex-col ml-4 mr-auto font-bold">
          <div className="text-xs">経済指標や取引履歴など</div>
          <div className="text-base">お知らせ設定</div>
        </div>
        <div className="h-full w-8 flex items-center justify-center bg-bluegray-50 rounded-r-lg">
          <div className="icon-chevron-right text-2xl text-bluegray-400"></div>
        </div>
      </div>
    </>
  );
};
